import {
  SelectCellFormatter,
  type RenderCellProps,
  type RenderHeaderCellProps,
  useRowSelection,
} from 'components/DataGrid';
import type { ReactElement, ReactNode } from 'react';
import type { Column } from 'components/DataGrid';
import type { GridSummaryRow, RowOrGroup } from '../../types';

function HeaderRenderer(props: RenderHeaderCellProps<RowOrGroup, GridSummaryRow>): ReactElement {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <SelectCellFormatter
      aria-label="Select All"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'HEADER', checked });
      }}
    />
  );
}

function SelectFormatter(props: RenderCellProps<RowOrGroup, GridSummaryRow>): ReactNode {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();
  if (!props.row.isSelectable) {
    return null;
  }
  return (
    <SelectCellFormatter
      aria-label="Select"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked, isShiftClick) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick });
      }}
    />
  );
}

export const SelectColumn: Column<RowOrGroup, GridSummaryRow> = {
  key: 'select-row',
  name: '',
  width: 30,
  minWidth: 30,
  maxWidth: 30,
  frozen: true,
  resizable: false,
  sortable: false,
  renderHeaderCell: (props) => <HeaderRenderer {...props} />,
  cell: { renderCell: (props) => <SelectFormatter {...props} /> },
};
